var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnlargeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 359 359.1",
    style: {
      enableBackground: "new 0 0 359 359.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.3,299.3c63.1-70.4,60.8-179.1-6.9-246.8c-69.2-69.1-181.1-70.1-251.5-2.2c-70.4,67.9-73.6,179.7-7,251.4 s178.3,76.9,251.2,11.7 M66.5,292.4C3.9,230.4,3.4,129.3,65.5,66.6C127.5,4,228.6,3.5,291.3,65.6c0.4,0.4,0.7,0.7,1.1,1.1 c62.3,62.3,62.3,163.5,0,225.8C230.1,354.7,128.8,354.7,66.5,292.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.3,169.6h-49.9v-49.9c0-5.5-4.5-10-10-10c-5.5,0-10,4.5-10,10v49.9h-49.9c-5.5,0-10,4.5-10,10 c0,5.5,4.5,10,10,10h49.9v49.9c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10v-49.9h49.9c5.5,0,10-4.5,10-10 C249.3,174,244.8,169.6,239.3,169.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnlargeIcon);
export default __webpack_public_path__ + "static/media/enlarge_icon.3579b767db411d086ea7a2f52ae206af.svg";
export { ForwardRef as ReactComponent };